import React from 'react'
import { Link } from 'react-router-dom';
import { validate, validators, optional } from 'validate-redux-form';
import { renderField } from "Utils/renderField/renderField";
import { Field, reduxForm } from 'redux-form'
import { icons } from "icons";

const Form = props => {
    const { handleSubmit } = props;
    return (
        <form onSubmit={handleSubmit} className="row">
            <div className="col-sm-12">
                <div className="form-group grid-container">
                    <div className="grid-titulo padding-15">Edición</div>
                    <div className=" padding-15">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                <label htmlFor="nombre">Nombre de la sucursal*</label>
                                <Field name="nombre" component={renderField} type="text" className="form-control"/>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                <label htmlFor="direccion">Dirección</label>
                                <Field name="direccion" component={renderField} type="text" className="form-control"/>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                <label htmlFor="telefono">Teléfono</label>
                                <Field name="telefono" component={renderField} type="text" className="form-control"/>
                            </div>
                        </div>
                        <br/>
                        <div className="row">
                            <div className="col-sm-6 text-right">
                                <Link className="btn btn-tertiary" to="/configuracion/sucursales/"><img src={icons.cancelar} alt=""/>Cancelar</Link>
                            </div>
                            <div className="col-sm-6">
                                <button type="submit" className="btn btn-primary"><img src={icons.save} alt=""/>Guardar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
};

const SucursalForm = reduxForm({
    // a unique name for the form
    form: 'SucursalEditar',
    validate: data => {
        return validate(data, {
            nombre: validators.exists()('Campo requerido'),
        })
    }
})(Form);

export default SucursalForm
